<!-- #################################################################################### -->
<!-- ###### HERINCOHAN                                                             ###### -->
<!-- ###### @author: Diego Alexander Villalba Cely                                 ###### -->
<!-- ###### @date: Octubre 2023                                                    ###### -->
<!-- #################################################################################### -->

<!-- #################################################################################### -->
<!-- ###### Sección de HTML                                                        ###### -->
<!-- #################################################################################### -->
<template>
  <div class="body-PB">
    <iframe title="Informe 70 años" width="100%" height="100%"
      src="https://app.powerbi.com/view?r=eyJrIjoiYTM4Zjc4MWYtZTBmZi00OGNkLTgzM2UtMzFjNjgzZDI2MjI1IiwidCI6IjllMDQ0ZjE3LWM3M2MtNGU1ZC04NWViLTMyNDNlNTU1YjczOSIsImMiOjR9"
      frameborder="0" allowFullScreen="true"></iframe>
  </div>
</template>
         
         <!-- #################################################################################### -->
         <!-- ###### Sección de Scripts                                                     ###### -->
         <!-- #################################################################################### -->
<script>
export default {
  name: 'Informe60Anios',
}
</script>
         
         <!-- #################################################################################### -->
         <!-- ###### Sección de styles                                                      ###### -->
         <!-- #################################################################################### -->
<style scoped>
.body-PB {
  height: 93% !important;
}
</style>